export enum AuthSessionState {
  ANONYMOUS = "anonymous",
  AUTHENTICATED = "authenticated",
  REFRESH_UNAVAILABLE = "refresh-unavailable",
  EXPIRED = "expired",
}

export type AuthSession =
  | { state: AuthSessionState.AUTHENTICATED; accessToken: string }
  | {
      state:
        | AuthSessionState.ANONYMOUS
        | AuthSessionState.REFRESH_UNAVAILABLE
        | AuthSessionState.EXPIRED;
    };

export class AuthRefreshUnavailableError extends Error {
  constructor() {
    super("Auth refresh temporarily unavailable");
    this.name = "AuthRefreshUnavailableError";
  }
}

export class AuthSessionExpiredError extends Error {
  constructor() {
    super("Auth session expired");
    this.name = "AuthSessionExpiredError";
  }
}
